import { VALIDATION_ERROR_CODES } from '../types/upload';
import { DEFAULT_VALIDATION_RULES, MAX_SIZE_IN_MEGAPIXELS, VALID_URL_REGEX } from './constants';
import { getDimensionsErrorMessage, getFormatErrorMessage, getSizeErrorMessage, } from './error-messages';
import { bytesToMB, getImageDimensions, getImageSizeInMegapixels, mimeToImageFormat, } from './helpers';
export { DEFAULT_VALIDATION_RULES } from './constants';
export const isUrlValid = (url) => VALID_URL_REGEX.test(url);
export const fileHasValidSize = (source, size = DEFAULT_VALIDATION_RULES.size) => {
    const sizeToMB = bytesToMB(source.size);
    const isValid = sizeToMB <= size;
    return {
        success: isValid,
        ...(!isValid ? { validationMessage: getSizeErrorMessage(size, sizeToMB) } : {}),
    };
};
export const fileHasValidDimensions = async (source, dimensions = DEFAULT_VALIDATION_RULES.dimensions) => {
    let isValid = false;
    const { width, height } = await getImageDimensions(source);
    const sizeInMegaPixels = getImageSizeInMegapixels(width, height);
    // We limit the size to 16 megapixels
    if (sizeInMegaPixels > MAX_SIZE_IN_MEGAPIXELS)
        return {
            success: false,
            validationMessage: getDimensionsErrorMessage(dimensions, { width, height }),
        };
    isValid =
        width <= dimensions.maxWidth &&
            width >= dimensions.minWidth &&
            height <= dimensions.maxHeight &&
            height >= dimensions.minHeight;
    return {
        success: isValid,
        ...(!isValid
            ? { validationMessage: getDimensionsErrorMessage(dimensions, { width, height }) }
            : {}),
    };
};
export const fileHasValidFormat = (source, allowedFormats = DEFAULT_VALIDATION_RULES.format) => {
    const sourceFormat = mimeToImageFormat(source.type);
    const isFormatValid = sourceFormat !== undefined && allowedFormats.includes(sourceFormat);
    return {
        success: isFormatValid,
        ...(!isFormatValid
            ? { validationMessage: getFormatErrorMessage(allowedFormats, source.type) }
            : {}),
    };
};
function checkIsRasterImageFile(source) {
    return !(source.type === 'image/svg+xml' || source.type === 'application/pdf');
}
export const validateImageFile = async (source, options) => {
    const formatValidation = fileHasValidFormat(source, options?.validations?.format);
    const isRasterImageFile = checkIsRasterImageFile(source);
    const errors = [];
    const sizeValidation = fileHasValidSize(source, options?.validations?.size);
    const dimensionsValidation = isRasterImageFile
        ? await fileHasValidDimensions(source, options?.validations?.dimensions)
        : { success: true };
    if (!sizeValidation.success)
        errors.push({
            errorType: VALIDATION_ERROR_CODES.InvalidFileSize,
            message: sizeValidation.validationMessage || '',
        });
    if (!dimensionsValidation.success)
        errors.push({
            errorType: VALIDATION_ERROR_CODES.InvalidFileDimensions,
            message: dimensionsValidation.validationMessage || '',
        });
    if (!formatValidation.success)
        errors.push({
            errorType: VALIDATION_ERROR_CODES.InvalidFileFormat,
            message: formatValidation.validationMessage || '',
        });
    const isImageValid = errors.length === 0;
    return { success: isImageValid, errors };
};
export const validateImageUrl = (source) => {
    const validationResult = isUrlValid(source);
    return {
        success: validationResult,
        ...(!validationResult
            ? {
                error: {
                    errorType: VALIDATION_ERROR_CODES.InvalidUrlFormat,
                    message: `Invalid URL. The URL is: ${source}`,
                },
            }
            : {}),
    };
};
//# sourceMappingURL=index.js.map